import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import './ProjectDetail.css';

function getYouTubeId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|v=|embed\/)([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
}

export default function ProjectDetail() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('projects')
      .select('*')
      .eq('id', id)
      .single()
      .then(({ data }) => {
        setProject(data);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div className="pd__loading"><span>Loading...</span></div>;
  if (!project) return <div className="pd__loading"><span>Project not found.</span></div>;

  const ytId = getYouTubeId(project.video_url);

  return (
    <main className="pd">
      <div className="pd__back">
        <Link to="/work" className="pd__back-link">← BACK TO WORK</Link>
      </div>

      <div className="pd__video-wrap">
        {ytId ? (
          <iframe
            className="pd__video"
            src={`https://www.youtube.com/embed/${ytId}`}
            title={project.title}
            allowFullScreen
          />
        ) : project.thumbnail_url ? (
          <img src={project.thumbnail_url} alt={project.title} className="pd__cover" />
        ) : (
          <div className="pd__placeholder">
            <span>No media available</span>
          </div>
        )}
      </div>

      <div className="pd__info">
        <div className="pd__meta">
          <h1 className="pd__title">{project.title}</h1>
          <div className="pd__tags">
            {(project.tags || []).map(t => (
              <span key={t} className="pd__tag">{t}</span>
            ))}
          </div>
        </div>
        <p className="pd__category">{project.category}</p>
        {project.description && (
          <p className="pd__desc">{project.description}</p>
        )}
        {project.video_url && !ytId && (
          <a href={project.video_url} target="_blank" rel="noreferrer" className="pd__ext-link">
            Watch Project ↗
          </a>
        )}
      </div>
    </main>
  );
}
